export default __webpack_public_path__ + "static/media/c1.e78a926b.png";